import type { InsertReviewCommentsOptions } from '../../api/word/word-service'
import type { CommentReply, ReviewComment, ReviewCommentItem } from '../../types/chat'

export function partitionReviewCommentItems(items: ReviewCommentItem[]) {
  const inserts: ReviewComment[] = []
  const replies: CommentReply[] = []

  for (const item of items) {
    if (item.kind === 'insert') inserts.push(item.comment)
    if (item.kind === 'reply') replies.push(item.reply)
  }

  return { inserts, replies }
}

export function buildInsertReviewCommentsOptions(args: {
  resolveDocumentWide?: boolean
  selectionParagraphIds: string[]
}): InsertReviewCommentsOptions {
  const resolveDocumentWide = args.resolveDocumentWide === true
  return {
    selectionParagraphIds: resolveDocumentWide ? [] : args.selectionParagraphIds,
    resolveDocumentWide,
  }
}
